import { formatDateTime } from "../constants/pollOptions";

/** Quotes a cell only when it would otherwise break the row. */
function cell(value) {
  const text = value === null || value === undefined ? "" : String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

const row = (cells) => cells.map(cell).join(",");

const HEADER = [
  "Poll Title",
  "Poll Question",
  "Response Type",
  "Anonymous",
  "Total Targeted",
  "Total Responses",
  "Pending Responses",
  "Participation %",
  "Respondent",
  "Response",
  "Non-Respondent",
  "Poll Closed Date",
];

/**
 * Builds the results sheet as one column-oriented table.
 *
 * <p>Respondents and non-respondents run down their own columns side by side,
 * so a row carries the i-th of each and the shorter column simply runs out.
 * The poll summary and its close date are single values, so they sit on the
 * first data row and the cells below them stay empty rather than repeating.
 */
export function buildResultsCsv(poll, results, participants) {
  const respondents = participants?.respondents ?? [];
  const nonRespondents = participants?.nonRespondents ?? [];

  const totalTargeted = results?.totalTargeted ?? 0;
  const totalResponses = results?.totalResponses ?? 0;
  const pending = results?.pending ?? Math.max(totalTargeted - totalResponses, 0);
  const participation = totalTargeted
    ? Math.round((totalResponses / totalTargeted) * 100)
    : 0;

  const closedOn = poll?.status === "Closed" ? formatDateTime(poll.endDateTime) : "";

  const lines = [row(HEADER)];

  // Always emit one row so the summary has somewhere to sit, even on an
  // anonymous poll where no participant list is available to anyone.
  const dataRows = Math.max(respondents.length, nonRespondents.length, 1);
  for (let i = 0; i < dataRows; i += 1) {
    const respondent = respondents[i];
    const nonRespondent = nonRespondents[i];
    const first = i === 0;
    lines.push(
      row([
        first ? poll?.pollTitle : "",
        first ? poll?.pollQuestion : "",
        first ? poll?.responseType : "",
        first ? (poll?.anonymous ? "Yes" : "No") : "",
        first ? totalTargeted : "",
        first ? totalResponses : "",
        first ? pending : "",
        first ? participation : "",
        respondent?.name ?? "",
        respondent?.answer ?? "",
        nonRespondent?.name ?? "",
        first ? closedOn : "",
      ])
    );
  }

  return lines.join("\r\n");
}
